import { UserButton } from "@clerk/react";
import { Clock } from "lucide-react";
import { useMe } from "@/context/MeContext";

export default function Pending() {
  const me = useMe();
  return (
    <div className="min-h-screen bg-[#F5F5F4] flex items-center justify-center p-6" data-testid="pending-page">
      <div className="bg-white border border-stone-200 rounded-lg p-10 max-w-md w-full">
        <div className="flex items-center justify-between">
          <Clock className="h-6 w-6 text-[#C2410C]" />
          <UserButton />
        </div>
        <h1 className="font-heading text-2xl font-black tracking-tight text-stone-900 mt-6">Accès en attente</h1>
        <p className="text-sm text-stone-600 mt-3 leading-relaxed">
          Votre compte <span className="font-medium text-stone-900">{me.email}</span> a bien été créé. Un super-administrateur doit vous attribuer un rôle avant que vous puissiez accéder à la plateforme.
        </p>
      </div>
    </div>
  );
}
